import { router } from '@inertiajs/react';
import { useEffect, useState } from 'react';

export default function useLoading() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    router.on('start', () => setLoading(true));
    router.on('finish', () => setLoading(false));
  }, []);

  return loading;
}
